import { render, staticRenderFns } from "./aprovadas.vue?vue&type=template&id=cd3486ce&scoped=true"
import script from "./aprovadas.vue?vue&type=script&lang=js"
export * from "./aprovadas.vue?vue&type=script&lang=js"
import style0 from "./aprovadas.vue?vue&type=style&index=0&id=cd3486ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd3486ce",
  null
  
)

export default component.exports